import { render, staticRenderFns } from "./bottomBox.vue?vue&type=template&id=9fce68ce&scoped=true"
import script from "./bottomBox.vue?vue&type=script&lang=js"
export * from "./bottomBox.vue?vue&type=script&lang=js"
import style0 from "./bottomBox.vue?vue&type=style&index=0&id=9fce68ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fce68ce",
  null
  
)

export default component.exports